import ListingPage from "../components/ListingPage";
import CreateConfigurationPage from "../components/CreateConfiguration.vue";
import DetailsTabs from "../components/DetailsTabs.vue";
import DetailsPage from "../components/DetailsPage.vue";
import ShrinkageTab from "../components/formParts/tabs/shrinkage/ShrinkageTab.vue";
import LeaveTab from "../components/formParts/tabs/leave/LeaveTab.vue";
import StaffingPage from "../components/staffing/StaffingPage.vue";
import StaffingTable from "../components/staffing/table/StaffingTable.vue";
import SchedulePage from "../components/schedule/SchedulePage.vue";
import { NotFound } from "@agyletime/wfm-vue-common";

const routes = [
  {
    name: "home",
    path: "/",
    component: ListingPage,
    meta: {
      text: "capacity-planner",
      breadcrumbs: [],
    },
  },
  {
    name: "details-tabs",
    path: `/view/:id`,
    component: DetailsTabs,
    meta: {
      text: "capacity-planner-breadcrumb-details-view",
      breadcrumbs: [{ name: "home", text: "capacity-planner-breadcrumb-home" }],
    },
    children: [
      {
        name: "staffing-view",
        path: "staffing",
        component: StaffingPage,
        children: [
          {
            path: "staffing",
            name: "staffing-table",
            component: StaffingTable,
          },
        ],
      },
      {
        name: "details-view",
        path: `details`,
        component: DetailsPage,
        children: [
          {
            path: ":month/leave",
            name: "leave",
            component: LeaveTab,
          },
          {
            path: ":month/shrinkage",
            name: "shrinkage",
            component: ShrinkageTab,
          },
        ],
      },
      {
        name: "schedule-view",
        path: "schedule",
        component: SchedulePage,
      },
    ],
  },
  {
    name: "create-configuration",
    path: "/create-configuration",
    component: CreateConfigurationPage,
    meta: {
      text: "capacity-planner-breadcrumb-create-configuration",
      breadcrumbs: [{ name: "home", text: "capacity-planner-breadcrumb-home" }],
    },
  },
  {
    name: "edit-configuration",
    path: `/edit-configuration/:id`,
    component: CreateConfigurationPage,
    meta: {
      text: "capacity-planner-breadcrumb-edit-configuration",
      breadcrumbs: [
        {
          name: "home",
          text: "capacity-planner-breadcrumb-home",
        },
        {
          name: "details-view",
          text: "capacity-planner-breadcrumb-details-view",
        },
      ],
    },
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
    name: "NotFound",
    meta: {
      text: "capacity-planner-breadcrumb-not-found",
      breadcrumbs: [{ name: "home", text: "capacity-planner-breadcrumb-home" }],
    },
  },
];

export default routes;
